
import { Vue, Component, Prop,Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "NSelect",
  components: {
  },
})
export default class NSelect extends BaseVue {
  @Prop({ default: () => true }) changeOnSelect!: Boolean; //当此项为 true 时，点选每级菜单选项值都会发生变化
  @Model('on-change') defaultValue!: any

  areaListData:any=[]
  mounted() {
    // console.log(this.defaultValue)
  }

  SelectAreaEvent(value){
    // vue 原生的方法 return 出去
    this.$emit("on-change",value)
    // 当前model 赋值
    this.defaultValue = value;
  }
  loadValue(){    
    if(this.isNull(this.defaultValue)){
      this.$emit("on-change",[])
    }
    if(typeof(this.defaultValue)=="number"){
      this.$emit("on-change",[this.defaultValue.toString()])
    }
    if(typeof(this.defaultValue)!="object"){
      this.$emit("on-change",this.defaultValue.split(","))
    }
    return this.defaultValue
  }

}
